import React from "react";
import { ExcelTableView, XlsxTableLoaderView } from "./ExcelTableView";
import { ExcelFileType } from "../XlsxTableView/ExcelTableViewBloc";
export function XlsxTableView(props) {
  var _props$createBlobUrl, _props$textAreaValue, _props$textAreaValue2, _props$textAreaValue3;
  if (((_props$createBlobUrl = props.createBlobUrl) === null || _props$createBlobUrl === void 0 ? void 0 : _props$createBlobUrl.objectURL) === undefined) {
    return /*#__PURE__*/React.createElement(XlsxTableLoaderView, null);
  }
  var fileType = ExcelFileType.XLSX;
  if (((_props$textAreaValue = props.textAreaValue) === null || _props$textAreaValue === void 0 || (_props$textAreaValue = _props$textAreaValue.format) === null || _props$textAreaValue === void 0 ? void 0 : _props$textAreaValue.toUpperCase()) === "XLSX") {
    fileType = ExcelFileType.XLSX;
  } else if (((_props$textAreaValue2 = props.textAreaValue) === null || _props$textAreaValue2 === void 0 || (_props$textAreaValue2 = _props$textAreaValue2.format) === null || _props$textAreaValue2 === void 0 ? void 0 : _props$textAreaValue2.toUpperCase()) === "CSV") {
    fileType = ExcelFileType.CSV;
  } else {
    return /*#__PURE__*/React.createElement("div", null, "Can't Read");
  }
  return /*#__PURE__*/React.createElement(ExcelTableView, {
    fileUrl: props.createBlobUrl.objectURL,
    name: (_props$textAreaValue3 = props.textAreaValue) === null || _props$textAreaValue3 === void 0 ? void 0 : _props$textAreaValue3.name,
    fileType: fileType,
    noWheelClassName: props.noWheelClassName,
    nodeId: props.id,
    setNodes: props.setNodes
  });
}